import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { addCommas, removeNonNumeric } from '@helper';
import { Counter, CustomerInfo, Page, Loading, Error } from '@components';
import Notice from '@components/Layout/Notice';
import Complete from '@components/Complete/Complete';
import ApplyReturnModal from './components/ApplyReturnModal';
import TransFlagModal from '@components/Layout/TransFlagModal';
import HighGradeModal from './components/HighGradeModal';
const Return = () => {
    const {
        ReturnStore: {
            setCount,
            updateData,
            returnComplete,
            userCollateral,
            getCollateralList,
            nonHQCollateralList,
            isLoading,
            getReturnBusinessTime,
            transType,
            transInfoVisible,
            returnSwitchVisible,
            loadingFailed,
            msg,
            transFlagModalVisible,
            closeTransFlagModal,
            returnCollateralSwitchMessage,
            highGradeCollateralSwitch,
            TransMsg,
        },
        AuthStore: { borrowingAmount, updateUserInfo },
    } = useStore();
    const navigate = useNavigate();
    useEffect(() => {
        getCollateralList();
        if (returnComplete) {
            setTimeout(() => {
                navigate(0);
            }, 3000);
        }
    }, [returnComplete]);
    useEffect(() => {
        getReturnBusinessTime();
    }, [transType]);
    let mtRate = 0;
    const currentTotal = userCollateral.reduce(
        (preVal, curVal) =>
            preVal + (curVal.qty - curVal.returnQty) * 1000 * curVal.closePrice,
        0
    );
    const [returnOK, setReturnOK] = useState();
    // 非優質已全選?
    const [fillNonHG, setFillNonHG] = useState(false);
    // 優質有數量
    const [hasHGSelect, setHasHGSelect] = useState(false);
    // 優質總量
    const [totalHG, setTotalHG] = useState(0);
    const [calChange, setCalChange] = useState(0);
    const [beforeValue, setBeforeValue] = useState(0);
    mtRate = (currentTotal / borrowingAmount) * 100;
    const returnSum = userCollateral.reduce(
        (preVal, curVal) => preVal + curVal.returnQty,
        0
    );

    useEffect(() => {
        if (nonHQCollateralList.length > 0) {
            const hqObj = {};
            nonHQCollateralList.forEach(element => {
                hqObj[element.stockNo] = false;
            });
            setReturnOK(hqObj);
        }
    }, [nonHQCollateralList]);
    useEffect(() => {
        for (const i in returnOK) {
            if (returnOK[i] === false) {
                setFillNonHG(false);
                return;
            }
        }
        // 已全選非優質擔保品
        setFillNonHG(true);
    }, [returnOK]);
    return (
        <Page>
            <div className="container">
                <CustomerInfo title={'退還擔保品'} />
                <div className="card wow fadeInDown">
                    {isLoading ? (
                        <Loading isLoading={isLoading} />
                    ) : !returnComplete ? (
                        <div className="card-body tab-content">
                            <h3 className="title fw-bolder">
                                設定退還擔保品條件
                            </h3>
                            <div
                                className={
                                    highGradeCollateralSwitch
                                        ? 'tag_quality text-center text-white ms-0 d-inline-block cur-pointer'
                                        : 'd-none'
                                }
                                onClick={() => {
                                    updateData('highGradeModalVisible', true);
                                }}
                            >
                                優
                            </div>
                            <span
                                className={
                                    highGradeCollateralSwitch
                                        ? 'text-black2 align-text-bottom fw-bolder cur-pointer'
                                        : 'd-none'
                                }
                                onClick={() => {
                                    updateData('highGradeModalVisible', true);
                                }}
                            >
                                優質擔保品定義
                            </span>
                            {/* 退還擔保品鎖定 */}
                            <div
                                className={
                                    returnSwitchVisible
                                        ? 'd-none'
                                        : 'message-box position-relative'
                                }
                            >
                                <i className="icon_info list-inline-item align-middle "></i>
                                <div className="d-sm-inline-block h-r3">
                                    {/* 線上退還擔保品暫停服務，請洽所屬營業員或分公司協助辦理，造成不便敬請見諒。 */}
                                    {returnCollateralSwitchMessage}
                                </div>
                            </div>
                            {returnSwitchVisible && (
                                <div
                                    className={
                                        transInfoVisible
                                            ? 'd-none'
                                            : 'message-box position-relative'
                                    }
                                >
                                    <i className="icon_info list-inline-item align-middle"></i>
                                    15:00 - 次營業日 9:00，
                                    <div className="d-sm-inline-block">
                                        退還擔保品暫停服務
                                    </div>
                                </div>
                            )}

                            <div className="desk-show table-freezes overflow-auto">
                                <table
                                    cellSpacing={0}
                                    className="table table_sty"
                                >
                                    <thead>
                                        <tr>
                                            <th>股票代號</th>
                                            <th>股票名稱</th>
                                            <th>擔保品張數</th>
                                            <th>
                                                <div className="h-r">
                                                    收盤價
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                前一營業日收盤價
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                                    </OverlayTrigger>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="h-r2">
                                                    市值
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                前一營業日市值
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                                    </OverlayTrigger>
                                                </div>
                                            </th>
                                            <th>退還張數</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userCollateral.map(
                                            (
                                                {
                                                    stockNo,
                                                    stockName,
                                                    qty,
                                                    closePrice,
                                                    insiderFlag,
                                                    returnQty,
                                                    marketVal,
                                                    hQFlag,
                                                },
                                                index
                                            ) => {
                                                return (
                                                    <tr
                                                        key={`userCollateral_ ${index}`}
                                                    >
                                                        <th>
                                                            {(hQFlag === 1) &
                                                            highGradeCollateralSwitch ? (
                                                                <div className="tag_quality text-center text-white  position-absolute">
                                                                    優
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}
                                                            <span className="co-name">
                                                                {stockNo}
                                                            </span>
                                                        </th>
                                                        <td>{stockName}</td>
                                                        <td>
                                                            <div className="num_qut t-r3">
                                                                {qty}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div
                                                                className={`num_price t-r ${
                                                                    insiderFlag
                                                                        ? 'opacity-50'
                                                                        : ''
                                                                }`}
                                                            >
                                                                <span>$</span>
                                                                {closePrice}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div
                                                                className={`num_price t-r2 ${
                                                                    insiderFlag
                                                                        ? 'opacity-50'
                                                                        : ''
                                                                }`}
                                                            >
                                                                <span>$</span>
                                                                {addCommas(
                                                                    removeNonNumeric(
                                                                        Math.round(
                                                                            marketVal *
                                                                                100
                                                                        ) / 100
                                                                    )
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {!insiderFlag ? (
                                                                !!parseInt(
                                                                    userCollateral[
                                                                        index
                                                                    ].status
                                                                ) && (
                                                                    // 新版Counter，增加文字輸入
                                                                    <Counter
                                                                        value={
                                                                            returnQty
                                                                        }
                                                                        stockAmount={
                                                                            (hQFlag ===
                                                                                1) &
                                                                            (fillNonHG ===
                                                                                false) &
                                                                            highGradeCollateralSwitch
                                                                                ? 0
                                                                                : qty
                                                                        }
                                                                        increase={() => {
                                                                            // 非優質新增滿時true
                                                                            if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    0) &
                                                                                (qty ===
                                                                                    returnQty +
                                                                                        1)
                                                                            ) {
                                                                                setReturnOK(
                                                                                    {
                                                                                        ...returnOK,
                                                                                        [stockNo]: true,
                                                                                    }
                                                                                );
                                                                            }
                                                                            // 優質異動
                                                                            if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    1) &
                                                                                (returnQty +
                                                                                    1 >
                                                                                    0)
                                                                            ) {
                                                                                setTotalHG(
                                                                                    totalHG => {
                                                                                        const newTotalHG =
                                                                                            totalHG +
                                                                                            1;
                                                                                        return newTotalHG;
                                                                                    }
                                                                                );
                                                                                setHasHGSelect(
                                                                                    true
                                                                                );
                                                                            }
                                                                            setCount(
                                                                                {
                                                                                    index,
                                                                                    value:
                                                                                        returnQty +
                                                                                        1,
                                                                                }
                                                                            );
                                                                        }}
                                                                        decrease={() => {
                                                                            // 非優質沒滿時false
                                                                            if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    0) &
                                                                                (qty >
                                                                                    returnQty -
                                                                                        1)
                                                                            ) {
                                                                                setReturnOK(
                                                                                    {
                                                                                        ...returnOK,
                                                                                        [stockNo]: false,
                                                                                    }
                                                                                );
                                                                            }
                                                                            // 優質異動
                                                                            if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    1) &
                                                                                (returnQty -
                                                                                    1 >
                                                                                    0)
                                                                            ) {
                                                                                setTotalHG(
                                                                                    totalHG => {
                                                                                        const newTotalHG =
                                                                                            totalHG -
                                                                                            1;
                                                                                        return newTotalHG;
                                                                                    }
                                                                                );
                                                                                setHasHGSelect(
                                                                                    true
                                                                                );
                                                                            } else if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    1) &
                                                                                (returnQty -
                                                                                    1 ===
                                                                                    0)
                                                                            ) {
                                                                                setTotalHG(
                                                                                    totalHG => {
                                                                                        const newTotalHG =
                                                                                            totalHG -
                                                                                            1;
                                                                                        if (
                                                                                            newTotalHG ===
                                                                                            0
                                                                                        ) {
                                                                                            setHasHGSelect(
                                                                                                false
                                                                                            );
                                                                                        }
                                                                                        return newTotalHG;
                                                                                    }
                                                                                );
                                                                            }
                                                                            setCount(
                                                                                {
                                                                                    index,
                                                                                    value:
                                                                                        returnQty -
                                                                                        1,
                                                                                }
                                                                            );
                                                                        }}
                                                                        onChange={e => {
                                                                            if (
                                                                                isNaN(
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                )
                                                                            ) {
                                                                                e.target.value = 0;
                                                                            }
                                                                            if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    1) &
                                                                                (fillNonHG ===
                                                                                    false)
                                                                            ) {
                                                                                e.target.value = 0;
                                                                            }
                                                                            if (
                                                                                parseInt(
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                ) >
                                                                                qty
                                                                            ) {
                                                                                e.target.value =
                                                                                    qty;
                                                                            }
                                                                            // 非優質沒滿時false
                                                                            if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    0) &
                                                                                (qty +
                                                                                    '' !==
                                                                                    e
                                                                                        .target
                                                                                        .value)
                                                                            ) {
                                                                                setReturnOK(
                                                                                    {
                                                                                        ...returnOK,
                                                                                        [stockNo]: false,
                                                                                    }
                                                                                );
                                                                            } else if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    0) &
                                                                                (qty +
                                                                                    '' ===
                                                                                    e
                                                                                        .target
                                                                                        .value)
                                                                            ) {
                                                                                setReturnOK(
                                                                                    {
                                                                                        ...returnOK,
                                                                                        [stockNo]: true,
                                                                                    }
                                                                                );
                                                                            }

                                                                            // 優質異動
                                                                            if (
                                                                                highGradeCollateralSwitch &
                                                                                (hQFlag ===
                                                                                    1) &
                                                                                (e
                                                                                    .target
                                                                                    .value !==
                                                                                    0)
                                                                            ) {
                                                                                setTotalHG(
                                                                                    totalHG => {
                                                                                        const newTotalHG =
                                                                                            totalHG +
                                                                                            +(
                                                                                                e
                                                                                                    .target
                                                                                                    .value -
                                                                                                returnQty
                                                                                            );
                                                                                        if (
                                                                                            newTotalHG ===
                                                                                            0
                                                                                        ) {
                                                                                            setHasHGSelect(
                                                                                                false
                                                                                            );
                                                                                        } else {
                                                                                            setHasHGSelect(
                                                                                                true
                                                                                            );
                                                                                        }
                                                                                        return newTotalHG;
                                                                                    }
                                                                                );
                                                                            }
                                                                            setCount(
                                                                                {
                                                                                    index,
                                                                                    value: +e
                                                                                        .target
                                                                                        .value,
                                                                                }
                                                                            );
                                                                        }}
                                                                    />
                                                                )
                                                            ) : (
                                                                <b className="text-danger ps-3">
                                                                    內部人
                                                                </b>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <ul className="stock-list d-sm-none">
                                {userCollateral.map(
                                    (
                                        {
                                            stockNo,
                                            stockName,
                                            qty,
                                            closePrice,
                                            insiderFlag,
                                            returnQty,
                                            marketVal,
                                            hQFlag,
                                        },
                                        index
                                    ) => {
                                        return (
                                            <li
                                                key={`userCollateral ${index}`}
                                                className="d-flex flex-wrap py-2 px-3 mb-3"
                                            >
                                                <div className="stock-choose d-flex  mb-2">
                                                    <div className="stock-name text-black2 col-8">
                                                        <span className="me-2">
                                                            {stockNo}
                                                        </span>
                                                        {stockName}
                                                    </div>
                                                    {!insiderFlag ? (
                                                        !!parseInt(
                                                            userCollateral[
                                                                index
                                                            ].status
                                                        ) && (
                                                            // 新版Counter，增加文字輸入
                                                            <Counter
                                                                value={
                                                                    returnQty
                                                                }
                                                                stockAmount={
                                                                    (hQFlag ===
                                                                        1) &
                                                                    (fillNonHG ===
                                                                        false) &
                                                                    highGradeCollateralSwitch
                                                                        ? 0
                                                                        : qty
                                                                }
                                                                increase={() => {
                                                                    // 非優質新增滿時true
                                                                    if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            0) &
                                                                        (qty ===
                                                                            returnQty +
                                                                                1)
                                                                    ) {
                                                                        setReturnOK(
                                                                            {
                                                                                ...returnOK,
                                                                                [stockNo]: true,
                                                                            }
                                                                        );
                                                                    }
                                                                    // 優質異動
                                                                    if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            1) &
                                                                        (returnQty +
                                                                            1 >
                                                                            0)
                                                                    ) {
                                                                        setTotalHG(
                                                                            totalHG => {
                                                                                const newTotalHG =
                                                                                    totalHG +
                                                                                    1;
                                                                                return newTotalHG;
                                                                            }
                                                                        );
                                                                        setHasHGSelect(
                                                                            true
                                                                        );
                                                                    }
                                                                    setCount({
                                                                        index,
                                                                        value:
                                                                            returnQty +
                                                                            1,
                                                                    });
                                                                }}
                                                                decrease={() => {
                                                                    // 非優質沒滿時false
                                                                    if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            0) &
                                                                        (qty >
                                                                            returnQty -
                                                                                1)
                                                                    ) {
                                                                        setReturnOK(
                                                                            {
                                                                                ...returnOK,
                                                                                [stockNo]: false,
                                                                            }
                                                                        );
                                                                    }
                                                                    // 優質異動
                                                                    if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            1) &
                                                                        (returnQty -
                                                                            1 >
                                                                            0)
                                                                    ) {
                                                                        setTotalHG(
                                                                            totalHG => {
                                                                                const newTotalHG =
                                                                                    totalHG -
                                                                                    1;
                                                                                return newTotalHG;
                                                                            }
                                                                        );
                                                                        setHasHGSelect(
                                                                            true
                                                                        );
                                                                    } else if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            1) &
                                                                        (returnQty -
                                                                            1 ===
                                                                            0)
                                                                    ) {
                                                                        setTotalHG(
                                                                            totalHG => {
                                                                                const newTotalHG =
                                                                                    totalHG -
                                                                                    1;
                                                                                if (
                                                                                    newTotalHG ===
                                                                                    0
                                                                                ) {
                                                                                    setHasHGSelect(
                                                                                        false
                                                                                    );
                                                                                }
                                                                                return newTotalHG;
                                                                            }
                                                                        );
                                                                    }
                                                                    setCount({
                                                                        index,
                                                                        value:
                                                                            returnQty -
                                                                            1,
                                                                    });
                                                                }}
                                                                onChange={e => {
                                                                    if (
                                                                        isNaN(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    ) {
                                                                        e.target.value = 0;
                                                                    }
                                                                    if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            1) &
                                                                        (fillNonHG ===
                                                                            false)
                                                                    ) {
                                                                        e.target.value = 0;
                                                                    }
                                                                    if (
                                                                        parseInt(
                                                                            e
                                                                                .target
                                                                                .value
                                                                        ) > qty
                                                                    ) {
                                                                        e.target.value =
                                                                            qty;
                                                                    }
                                                                    // 非優質沒滿時false
                                                                    if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            0) &
                                                                        (qty +
                                                                            '' !==
                                                                            e
                                                                                .target
                                                                                .value)
                                                                    ) {
                                                                        setReturnOK(
                                                                            {
                                                                                ...returnOK,
                                                                                [stockNo]: false,
                                                                            }
                                                                        );
                                                                    } else if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            0) &
                                                                        (qty +
                                                                            '' ===
                                                                            e
                                                                                .target
                                                                                .value)
                                                                    ) {
                                                                        setReturnOK(
                                                                            {
                                                                                ...returnOK,
                                                                                [stockNo]: true,
                                                                            }
                                                                        );
                                                                    }

                                                                    // 優質異動
                                                                    if (
                                                                        highGradeCollateralSwitch &
                                                                        (hQFlag ===
                                                                            1) &
                                                                        (e
                                                                            .target
                                                                            .value !==
                                                                            0)
                                                                    ) {
                                                                        setTotalHG(
                                                                            totalHG => {
                                                                                const newTotalHG =
                                                                                    totalHG +
                                                                                    +(
                                                                                        e
                                                                                            .target
                                                                                            .value -
                                                                                        returnQty
                                                                                    );
                                                                                if (
                                                                                    newTotalHG ===
                                                                                    0
                                                                                ) {
                                                                                    setHasHGSelect(
                                                                                        false
                                                                                    );
                                                                                } else {
                                                                                    setHasHGSelect(
                                                                                        true
                                                                                    );
                                                                                }
                                                                                return newTotalHG;
                                                                            }
                                                                        );
                                                                    }
                                                                    setCount({
                                                                        index,
                                                                        value: +e
                                                                            .target
                                                                            .value,
                                                                    });
                                                                }}
                                                            />
                                                        )
                                                    ) : (
                                                        <b className="text-danger ps-3">
                                                            內部人
                                                        </b>
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-baseline">
                                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                                        <small className="gray-light me-1">
                                                            擔保品張數
                                                        </small>
                                                        <span className="text-black2">
                                                            {qty}
                                                        </span>
                                                    </div>
                                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                                        <small className="gray-light me-1">
                                                            收盤
                                                        </small>
                                                        <span
                                                            className={`price text-black2 ${
                                                                insiderFlag
                                                                    ? 'opacity-50'
                                                                    : ''
                                                            }`}
                                                        >
                                                            <span>$</span>
                                                            {closePrice}
                                                        </span>
                                                    </div>
                                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                                        <small className="gray-light me-1">
                                                            市值
                                                        </small>
                                                        <span
                                                            className={`price text-black2 ${
                                                                insiderFlag
                                                                    ? 'opacity-50'
                                                                    : ''
                                                            }`}
                                                        >
                                                            {addCommas(
                                                                removeNonNumeric(
                                                                    Math.round(
                                                                        marketVal *
                                                                            100
                                                                    ) / 100
                                                                )
                                                            )}
                                                        </span>
                                                        {(hQFlag === 1) &
                                                        highGradeCollateralSwitch ? (
                                                            <span className="tag_quality text-center text-white  ">
                                                                優
                                                            </span>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    }
                                )}
                            </ul>

                            <div className="totalbox text-end py-3">
                                <p className="price">
                                    <label className="text-black2 align-text-bottom fw-bolder">
                                        退還以上擔保品，試算維持率為
                                    </label>
                                    {!returnSum ? (
                                        <b className="text-danger ps-3">
                                            尚未輸入張數
                                        </b>
                                    ) : (
                                        <b className="text-orange fit-3 ps-3">
                                            {/* {Math.floor(mtRate * 100) / 100} */}
                                            {borrowingAmount
                                                ? Math.floor(mtRate * 100) / 100
                                                : 0}
                                            <span>%</span>
                                        </b>
                                    )}
                                </p>
                                <p
                                    className={
                                        highGradeCollateralSwitch
                                            ? 'p-warn text-danger text-end fs-12'
                                            : 'd-none'
                                    }
                                >
                                    請優先退還一般擔保品再退還優質擔保品
                                </p>
                                <p
                                    className={
                                        mtRate < 166
                                            ? 'p-warn text-danger text-end fs-12'
                                            : 'd-none'
                                    }
                                >
                                    退還以上擔保品造成您維持率不足，請減少退還張數
                                </p>
                            </div>

                            <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                                <button
                                    className="btn_cancel m-border-0 btn rounded-pill text-end text-sm-center"
                                    type="button"
                                    onClick={() => {
                                        for (const index in userCollateral) {
                                            setCount({ index, value: 0 });
                                        }
                                    }}
                                >
                                    清 除
                                </button>
                                <button
                                    className={
                                        'btn_check btn rounded-pill text-white'
                                    }
                                    onClick={async () => {
                                        const [, getTransFlag] =
                                            await updateUserInfo();
                                        // 清空優質擔保品已被設定數量
                                        if (
                                            (fillNonHG === false) &
                                            (hasHGSelect === true)
                                        ) {
                                            for (const i in userCollateral) {
                                                if (
                                                    (userCollateral[i]
                                                        .hQFlag ===
                                                        1) &
                                                    (userCollateral[i]
                                                        .returnQty !==
                                                        0)
                                                ) {
                                                    userCollateral[
                                                        i
                                                    ].returnQty = 0;
                                                }
                                            }
                                        }
                                        if (getTransFlag === '1') {
                                            updateData(
                                                'TransMsg',
                                                '您已完成登入，系統資料尚在更新中，請稍候再申請。'
                                            );
                                        } else if (getTransFlag === '2') {
                                            updateData(
                                                'TransMsg',
                                                '作業中，請稍後再申請！'
                                            );
                                        }
                                        if (
                                            getTransFlag === '1' ||
                                            getTransFlag === '2'
                                        ) {
                                            updateData(
                                                'transFlagModalVisible',
                                                true
                                            );
                                        } else {
                                            updateData(
                                                'transFlagModalVisible',
                                                false
                                            );
                                            updateData(
                                                'applyReturnModalVisible',
                                                true
                                            );
                                        }
                                    }}
                                    disabled={
                                        mtRate < 166 ||
                                        !returnSum ||
                                        !transInfoVisible ||
                                        // 退還擔保品鎖定
                                        !returnSwitchVisible ||
                                        hasHGSelect & !fillNonHG
                                    }
                                >
                                    申 請
                                </button>
                            </div>
                        </div>
                    ) : (
                        <Complete
                            feature={'退還擔保品'}
                            remindText={'審核成功後，股票退還您庫存中'}
                            loadingFailed={loadingFailed}
                            msg={msg}
                        />
                    )}
                    {/* {loadingFailed && <Error msg={msg} />} */}

                    <Notice>
                        <li>營業日9:00~15:00申請，當日退還擔保品。</li>
                        <li className="red">退還後維持率需高於166％。</li>
                        <li>
                            發行公司之董事、監察人、經理人及持股超過股份總額百分之十股東，請臨櫃辦理質權設定。
                        </li>
                    </Notice>
                </div>
                <TransFlagModal
                    visibleHandler={transFlagModalVisible}
                    closeModal={closeTransFlagModal}
                    msg={TransMsg}
                />
                <ApplyReturnModal mtRate={mtRate} />
                <HighGradeModal />
            </div>
        </Page>
    );
};

export default observer(Return);
